import React from "react";
import styles from "./about.module.css";
import Container from "react-bootstrap/Container";
import AboutImg from "../../images/aboutus.jpg";

function About() {
  return (
    <Container>
      <section className={styles.about} id="about">
        <div className="title">
          <h2>من نحن</h2>
        </div>

        <div className={styles.about__content}>
          <div className={styles.about__text}>
            <p>
              تقدم <span>Core Tech Solutions </span>
              مجموعة من الخدمات المتعلقة بأجهزة الكمبيوتر والشبكات ، بما في ذلك
              تثبيت الأجهزة والبرامج وصيانتها ، واستكشاف الأخطاء وإصلاحها ،
              والنسخ الاحتياطي للبيانات واستعادتها ، وأمن الشبكات ، واستشارات
              تكنولوجيا المعلومات. قد يتم تقديم هذه الخدمات للأفراد أو الشركات ،
              وقد تشمل الدعم في الموقع والدعم عن بُعد. الهدف من هذه الشركة هو
              مساعدة العملاء على ضمان عمل أنظمة الكمبيوتر والشبكات الخاصة بهم
              على النحو الأمثل والأمان ، ومساعدتهم على معالجة أي مشكلات قد تنشأ.
              قد تختلف الخدمات المحددة التي تقدمها شركة خدمات الكمبيوتر والشبكات
              حسب احتياجات عملائها وخبراتهم في مختلف التقنيات.
            </p>
          </div>
          <div className={styles.about__img}>
            <img src={AboutImg} />
          </div>
        </div>
      </section>
    </Container>
  );
}

export default About;
